import React from 'react';
import { StyleSheet, TextInput, View } from 'react-native';
import { allStyles, placeholderTextColor } from './FormStyles';
import { translate } from './FormUtils';
import TitleLabel from './TitleLabel';

const styles = StyleSheet.create(allStyles);

export default function FieldText(props) {
    return (
        <View style={[styles.fieldContainer, props.containerStyle]}>
            <TitleLabel {...props}/>
            <TextInput
                editable={props.editable ?? true}
                style={[styles.textInput, (typeof props.value === 'string' && props.value.length > 0) ? styles.filledBox : {}, props.editable === false && styles.disabledBox]}
                value={props.value ?? ''}
                placeholderTextColor={placeholderTextColor}
                keyboardType={props.keyboardType}
                placeholder={`${translate(['FORM', 'ENTER'])}${props.title}`}
                onChange={(e) => {
                    props.onChange({
                        name: props.name,
                        value: e.nativeEvent.text,
                    })
                }}
                onBlur={() => {
                    props.onBlur(props.name);
                }}
            />
        </View>
    )
}